module.exports = __webpack_public_path__ + "static/img/userlogoClient.29dd4b9b.svg";